import { render, staticRenderFns } from "./OrgHomeMarketingSources.vue?vue&type=template&id=15cbbd03&scoped=true&"
import script from "./OrgHomeMarketingSources.vue?vue&type=script&lang=js&"
export * from "./OrgHomeMarketingSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cbbd03",
  null
  
)

export default component.exports